import { useEffect, useMemo, useRef, useState } from 'react';
import { apiRequest } from '../apiClient';
import { buildUiHelpers } from './sharedUi';
import './NewsletterPrompt.css';

export default function NewsletterPrompt({ COLORS, onStatusChange }) {
  const { Btn } = useMemo(() => buildUiHelpers({ COLORS, th: {} }), [COLORS]);
  const dialogRef = useRef(null);
  const titleRef = useRef(null);
  const [prompt, setPrompt] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    let active = true;
    apiRequest('/me/newsletter/prompt').then(data => { if (active) setPrompt(data); }).catch(() => {});
    return () => { active = false; };
  }, []);
  const visible = Boolean(prompt?.eligible && !dismissed);
  useEffect(() => {
    if (!visible) return;
    const dialog = dialogRef.current;
    const previousFocus = document.activeElement;
    dialog.showModal();
    titleRef.current?.focus();
    return () => { dialog.close(); previousFocus?.focus(); };
  }, [visible]);

  async function answer(subscribed) {
    setBusy(true);
    setError('');
    try {
      const data = await apiRequest('/me/newsletter/prompt', {
        method: 'POST', timeoutMs: 30000,
        body: { subscribed, consent_version: prompt.consent_version },
      });
      onStatusChange(data.status);
      if (data.status === 'pending') setMessage('Bitte bestätige die Newsletter-Anmeldung über den Link in deiner E-Mail.');
      else setDismissed(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  if (!visible) return null;
  return <dialog className="newsletter-prompt" ref={dialogRef} aria-labelledby="newsletter-prompt-title" aria-describedby="newsletter-prompt-consent" onCancel={event => { if (busy) event.preventDefault(); else setDismissed(true); }} style={{ boxSizing: 'border-box', width: 'calc(100% - 32px)', maxWidth: 520, maxHeight: 'calc(100dvh - 32px)', overflowY: 'auto', padding: 24, borderRadius: 8, border: `1px solid ${COLORS.border}`, background: COLORS.card, color: COLORS.text }}>
    <h2 ref={titleRef} tabIndex={-1} id="newsletter-prompt-title" style={{ margin: '0 0 16px', fontSize: 20, outline: 'none' }}>Möchtest du unseren Newsletter erhalten?</h2>
    <p id="newsletter-prompt-consent" style={{ fontSize: 14, lineHeight: 1.6 }}>{prompt.consent_text} <a href="https://www.einfach-trading.de/rechtliches.html" target="_blank" rel="noreferrer" style={{ color: COLORS.cyan }}>Datenschutz</a></p>
    {error && <p role="alert" style={{ color: COLORS.red }}>{error}</p>}
    {message ? <>
      <p role="status">{message}</p>
      <Btn onClick={() => setDismissed(true)}>Schließen</Btn>
    </> : <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginTop: 20 }}>
      <Btn onClick={() => answer(true)} disabled={busy}>Ja, möchte ich erhalten</Btn>
      <Btn color="ghost" onClick={() => answer(false)} disabled={busy}>Nein, möchte ich nicht</Btn>
    </div>}
  </dialog>;
}
